var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mg-review"},[_c('blw-illustration',{attrs:{"name":"cat-clock","size":"185"}}),_c('h1',{staticClass:"header-1 my-4"},[_vm._v("We’re reviewing the roommates’ decision")]),_c('p',{staticClass:"mb-4"},[_vm._v(" This process usually takes a few hours. We’ll notify you via email once we’ve reviewed their decision. ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }